<div class="content-header">
  <div class="content-wrapper">
    <div class="logo-container">
      <div class="logo">
        <img src="assets/img/Merch-Loop4.png" width="50">
        <span><strong>Merchloop </strong>Developers</span>
      </div>
    </div>
    <h1>
      Merchloop Public API Documentation <small>Version 1</small>
      <br />
      <small>
        Automate your Print on Demand business
      </small>
    </h1>

  </div>
</div>


<div class="front-wrap">
  <div class="front-store-content">
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <h3 id="overview">
            Overview
          </h3>
          <p>
            Integration with Merchloop requires 2 steps.
          </p>
          <ol>
            <li>
              <strong>Product setup</strong>:&nbsp;
              <span>Merchloop integration team will help you out in this regards.</span>
            </li>
            <li>
              <strong>API integration</strong>:&nbsp;
              <span>API implementation mentioned in this documentation done by the developers at your team.</span>
              <br />
              <ul typeof="i">
                <li>
                  Get an API key for authentication- Merchloop will provide you the authentication key.
                </li>
                <li>
                  Implement the APIs and test your integration on our testing environment before going live.
                  Test and Production endpoints will be provided by the Merchloop.
                </li>
                <li>
                  Once every thing goes fine in the test enviroment we help you to go live for production.
                </li>
              </ul>
            </li>
          </ol>
          <br />
          <p>
            If you have any technical questions, please send an email to
            <strong>hello&#64;merchloop.com.</strong>
          </p>


          <br />
          <hr />
          <br />

          <p>
            Merchloop Open API use REST architecture.
          </p>
          <ul>
            <!-- <li>All requests are done via HTTPs. Requests via insecure HTTP are not supported.</li> -->
            <li>
              Merchloop works with UTF-8 encoded data. Please make sure everything you send via API calls also uses
              UTF-8.
            </li>
            <li>
              All data received from and submitted to the API is structured in JSON, so the content type should be:
              application/json;charset=utf-8
            </li>
          </ul>


          <br />
          <p id="authentication">
            <strong class="head">Authentication</strong>
            <br />
            To ensure it works best for all parties, we require that the API is used in secure way.
          </p>
          <ul>
            <!-- <li>It is necessary to use HTTPS.</li> -->
            <li>
              <strong>API key authentication</strong> via HTTP headers should be used when communicating with the
              APIs. You must provide your API key with header parameter name X-API-KEY.
            </li>
          </ul>
          <p>The API key will be issued by Merchloop.</p>

          <br />
          <p id="order">
            <strong class="head">Order<sup class="api">API</sup></strong>
            <br />
            The Order API is used by you to submit an Order to be fulfilled by Merchloop.
            Merchloop receives an order request, accepts or rejects it, and if accepted proceeds with actual
            production and shipment of the Order.
          </p>
          <ul>
            <li>
              Endpoint - <strong>{{createOrderAPI}}</strong>, Type - POST
              <small>Create order</small>
            </li>
            <li>
              Endpoint - <strong>{{getOrderAPI}}</strong>, Type - GET
              <small>Get order</small>
            </li>
            <li>
              Endpoint - <strong>{{updateOrderAPI}}</strong>, Type - PUT
              <small>Update order</small>
            </li>
            <li>
              Endpoint - <strong>{{cancelOrderAPI}}</strong>, Type - POST
              <small>Cancel order</small>
            </li>
          </ul>

          <strong>Order properties</strong>
          <table>
            <tr>
              <td>
                id
                <small class="field-type-not-req">READ-ONLY</small>
              </td>
              <td>
                A unique string identifier for the Order. Each id should be unique across your system.
              </td>
            </tr>
            <tr>
              <td>
                reference_id
                <small>REQUIRED*</small>
              </td>
              <td>
                A unique string identifier for the Order in Merchloop.
                <br />
                (* - The property appears only in Get Order API)
              </td>
            </tr>
            <tr>
              <td>
                tags
                <small class="field-type-not-req">OPTIONAL</small>
              </td>
              <td>
                An array of tags to apply for an order. Represents additional order options. Currently, supported values below. List of supported tags could be extended.
                <div style="font-weight: 100;">sample - Indicating if this is a sample order.</div>
                <div style="font-weight: 100;">prioritised - Indicating if this is a prioritised order.</div>
                <div style="font-weight: 100;">ex. "tags": [
                  "prioritised",
                  "sample"
                ] </div>
              </td>
            </tr>
            <tr>
              <td>
                address_to
                <small>REQUIRED</small>
              </td>
              <td>
                Address to ship an Order to.
              </td>
            </tr>
            <tr>
              <td>
                address_from
                <small>REQUIRED</small>
              </td>
              <td>
                Address to return an Order to, in case of issues with shipping.
              </td>
            </tr>
            <tr>
              <td>
                shipping
                <small>REQUIRED</small>
              </td>
              <td>
                Shipping carrier configuration.
              </td>
            </tr>
            <tr>
              <td>
                items
                <small>REQUIRED</small>
              </td>
              <td>
                Individual products (items) to be printed and shipped to the customer.
              </td>
            </tr>
          </table>

          <strong>Address to properties</strong>
          <table>
            <tr>
              <td>
                address1
                <small>REQUIRED</small>
              </td>
              <td>
                First line of destination post address.
              </td>
            </tr>
            <tr>
              <td>
                address2
                <small class="field-type-not-req">OPTIONAL</small>
              </td>
              <td>
                Second line of destination post address. Contains suite, apartment number, etc. May be sent as an
                empty string.
              </td>
            </tr>
            <tr>
              <td>
                city
                <small>REQUIRED</small>
              </td>
              <td>
                Destination city name
              </td>
            </tr>
            <tr>
              <td>
                zip
                <small>REQUIRED</small>
              </td>
              <td>
                Destination ZIP code.
              </td>
            </tr>
            <tr>
              <td>
                country
                <small>REQUIRED</small>
              </td>
              <td>
                Destination country code. ISO 3166 country codes are used.
              </td>
            </tr>
            <tr>
              <td>
                region
                <small>REQUIRED</small>
              </td>
              <td>
                Destination state code. ISO 3166 state codes are used.
              </td>
            </tr>
            <tr>
              <td>
                first_name
                <small>REQUIRED</small>
              </td>
              <td>
                First name of package receiver.
              </td>
            </tr>
            <tr>
              <td>
                last_name
                <small>REQUIRED</small>
              </td>
              <td>
                Last name of package receiver.
              </td>
            </tr>
            <tr>
              <td>
                email
                <small class="field-type-not-req">OPTIONAL</small>
              </td>
              <td>
                Email of package receiver.
              </td>
            </tr>
            <tr>
              <td>
                phone
                <small class="field-type-not-req">OPTIONAL</small>
              </td>
              <td>
                Phone number of package receiver.
              </td>
            </tr>
          </table>

          <strong>Address from properties</strong>
          <table>
            <tr>
              <td>
                address1
                <small>REQUIRED</small>
              </td>
              <td>
                First line of return post address.
              </td>
            </tr>
            <tr>
              <td>
                address2
                <small class="field-type-not-req">OPTIONAL</small>
              </td>
              <td>
                Second line of return post address. Contains suite, apartment number, etc. May be sent as an empty
                string.
              </td>
            </tr>
            <tr>
              <td>
                city
                <small>REQUIRED</small>
              </td>
              <td>
                Return city name
              </td>
            </tr>
            <tr>
              <td>
                zip
                <small>REQUIRED</small>
              </td>
              <td>
                Return ZIP code.
              </td>
            </tr>
            <tr>
              <td>
                country
                <small>REQUIRED</small>
              </td>
              <td>
                Return country code. ISO 3166 country codes are used.
              </td>
            </tr>
            <tr>
              <td>
                region
                <small>REQUIRED</small>
              </td>
              <td>
                Return state code. ISO 3166 state codes are used.
              </td>
            </tr>
            <tr>
              <td>
                company
                <small>REQUIRED</small>
              </td>
              <td>
                Name of business for return address.
              </td>
            </tr>
            <tr>
              <td>
                email
                <small class="field-type-not-req">OPTIONAL</small>
              </td>
              <td>
                Email of the seller for return address.
              </td>
            </tr>
            <tr>
              <td>
                phone
                <small class="field-type-not-req">OPTIONAL</small>
              </td>
              <td>
                Phone number of the seller for return address.
              </td>
            </tr>
          </table>

          <strong>Item properties</strong>
          <table>
            <tr>
              <td>
                id
                <small>REQUIRED</small>
              </td>
              <td>
                Id of the line item for reference.
              </td>
            </tr>
            <tr>
              <td>
                sku
                <small>REQUIRED</small>
              </td>
              <td>
                SKU (Stock keeping unit) that represents what kind of product and variation to be used.
              </td>
            </tr>
            <tr>
              <td>
                preview_files
                <small>REQUIRED</small>
              </td>
              <td>
                List of image links. These image links must show product with designs representing how the product
                should look after printing.
                There can be images from different angles.
              </td>
            </tr>
            <tr>
              <td>
                print_files
                <small>REQUIRED</small>
              </td>
              <td>
                List of print image links. These links will contain print files to be used for printing purposes.
                These print files are tailored for the respective printing process.
                If there are multiple areas to be printed there will be multiple print files.
              </td>
            </tr>
            <tr>
              <td>
                quantity
                <small>REQUIRED</small>
              </td>
              <td>
                Represents the amount of items to be printed with this design.
              </td>
            </tr>
          </table>

          <strong>Create order</strong>
          <br />
          <div>
            <strong>Sample request body</strong>
            <div><code>{{createOrderAPI}}</code></div>
            <div class="div-code">
              <code [innerHtml]='orderSampleCode'></code>
            </div>
            <strong>Sample response - Status 200</strong>
            <div class="div-code">
              <code [innerHtml]='createOrderSuccess'></code>
            </div>
            <strong>Sample response - Status 400</strong>
            <div class="div-code">
              <code [innerHtml]='createOrderFailed'></code>
            </div>
            <strong>Sample response - Status 304</strong>
            <div>
              <p>Order already created.</p>
            </div>
          </div>

          <strong>Update order</strong>
          <p>
            <b class="text-danger">Note :</b>
            Only address_to, address_from and shipping can be updated.
          </p>

          <div>
            <strong>Cancel order</strong>
            <div>
              <b>Cancel the entire order or specific order items</b>
              <p>
                This endpoint will return HTTP status code 200.
                If it was not possible to cancel the entire order it will return error message and error code for each
                order item.
                Overall, if at least one item cancelation failed, the request status "success" may not be returned.
              </p>
            </div>
            <strong>Sample request</strong>
            <div class="div-code">
              <code [innerHtml]='cancelOrderRequest'></code>
            </div>
            <div>
              <p>
                <b class="text-danger">Note :</b>
                Do not send any request body if you want to cancel whole order.
              </p>
            </div>
            <strong>Sample response - 200</strong>
            <div class="div-code">
              <code [innerHtml]='cancelOrderSuccess'></code>
            </div>
            <strong>Sample response - 422</strong>
            <div class="div-code">
              <code [innerHtml]='cancelOrderError'></code>
            </div>
          </div>
          <br />
          <div>
            <p id="tracking">
              <strong class="head">Tracking <sup class="api">API</sup></strong>
              <br />
              The Tracking API is used to for fetching the status history and current state of an Order.
            </p>
            <ul>
              <li>
                Endpoint - <strong>{{trackingAPI}}</strong>, Type - GET
                <small>Get history and current state of an order</small>
              </li>
            </ul>
            <strong>Order tracking response properties</strong>
            <table>
              <tr>
                <td>
                  status
                </td>
                <td>
                  Current order status
                </td>
              </tr>
              <tr>
                <td>
                  events
                </td>
                <td>
                  Array of order events
                </td>
              </tr>
            </table>

            <strong>Tracking event response properties</strong>
            <table>
              <tr>
                <td>
                  time
                </td>
                <td>
                  Date and time in UTC when the event has occurred.
                </td>
              </tr>
              <tr>
                <td>
                  action
                </td>
                <td>
                  Order status.
                </td>
              </tr>
              <tr>
                <td>
                  affected_items
                </td>
                <td>
                  The list of affected items IDs.
                </td>
              </tr>
              <tr>
                <td>
                  tracking_url
                </td>
                <td>
                  Package tracking URL.
                </td>
              </tr>
              <tr>
                <td>
                  tracking_number
                </td>
                <td>
                  Package tracking number.
                </td>
              </tr>
              <tr>
                <td>
                  carrier
                </td>
                <td>
                  Shipping carrier.
                </td>
              </tr>
            </table>

            <strong>List of available statuses and events</strong>
            <table>
              <tr>
                <th>
                  Status
                </th>
                <th>
                  Description
                </th>
              </tr>
              <tr>
                <td>
                  created
                </td>
                <td>
                  An Order has been created and is waiting to be printed.
                </td>
              </tr>
              <tr>
                <td>
                  picked
                </td>
                <td>
                  An Order is picked to be printed.
                </td>
              </tr>
              <tr>
                <td>
                  printed
                </td>
                <td>
                  The item was printed and is awaiting shipping.
                </td>
              </tr>
              <tr>
                <td>
                  shipped
                </td>
                <td>
                  The package has been shipped.
                </td>
              </tr>
              <tr>
                <td>
                  canceled
                </td>
                <td>
                  The item have been canceled.
                </td>
              </tr>
            </table>

            <strong>Status 200 - Sample response</strong>
            <div class="div-code">
              <code [innerHtml]='trackingSampleResponse'></code>
            </div>
          </div>

          <br />
          <div>
            <p id="stock">
              <strong class="head">Stock <sup class="api">API</sup></strong>
              <br />
              The Stock API is used to fetch the inventory levels and pricing of the products.
            </p>
            <ul>
              <li>
                Endpoint - <strong>{{getAllStockAPI}}</strong>, Type - GET
                <small>Provide stock availability for products</small>
              </li>
              <li>
                Endpoint - <strong>{{getSKUStockAPI}}</strong>, Type - GET
                <small>Provide stock availability for single product SKU</small>
              </li>
              <li>
                Endpoint - <strong>{{getAllPricingAPI}}</strong>, Type - GET
                <small>Provide pricing information for products</small>
                <small class="text-danger">Note: Pricing will be different if order is marked as prioritised.</small>
              </li>
              <li>
                Endpoint - <strong>{{getSKUPricingAPI}}</strong>, Type - GET
                <small>Provide pricing information for single product SKU</small>
              </li>
            </ul>
            <strong>Stock item response properties</strong>
            <table>
              <tr>
                <td>
                  status
                </td>
                <td>
                  Current inventory state of a product variation.
                  <div>
                    <code [innerHtml]="invOptions"></code>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  stock
                </td>
                <td>
                  Amount of available items in an inventory (integer).
                </td>
              </tr>
            </table>

            <strong>Pricing item response properties</strong>
            <table>
              <tr>
                <td>
                  blank
                </td>
                <td>
                  Price for a blank product without print in USD cents.
                </td>
              </tr>
              <tr>
                <td>
                  processing
                </td>
                <td>
                  Processing fee for the item in USD cents. If there is no additional processing fee, it wil be set to 0.
                </td>
              </tr>
              <tr>
                <td>
                  printing
                </td>
                <td>
                  Price object for printing the item. Price can be divided into multiple offers depending on the areas being printed. Prices will be expressed in USD cents.
                  <div>
                    <code [innerHtml]="pricingPrintObj"></code>
                  </div>
                </td>
              </tr>
            </table>

            <strong>Get all stock inventory, 200 - Sample response</strong>
            <div class="div-code">
              <code [innerHtml]='getAllStockResponse'></code>
            </div>
            <strong>Get SKU stock inventory, 200 - Sample response</strong>
            <div class="div-code">
              <code [innerHtml]='getSKUStockResponse'></code>
            </div>
            <strong>Get all stock pricing, 200 - Sample response</strong>
            <div class="div-code">
              <code [innerHtml]='getAllPricingResponse'></code>
            </div>
            <strong>Get SKU stock pricing, 200 - Sample response</strong>
            <div class="div-code">
              <code [innerHtml]='getSKUPricingResponse'></code>
            </div>
          </div>
          
          <br />
          <div>
            <p id="webhook">
              <strong class="head">Webhooks</strong>
              <br />
              Configure your endpoints so that we can send you real time order updates.
            </p>

            <strong>Order status update events</strong>
            <div>
              <p>
                <b>Authorization :</b>
                ApiKey Header X-API-KEY
              </p>
            </div>
            
            <strong>Path Parameter</strong>
            <table>
              <tr>
                <td>
                  ORDER-ID
                </td>
                <td>
                  Your system Order Id. e.g - https://test.com/orders/event/{{'{ORDER-ID}'}}
                </td>
              </tr>
            </table>

            <strong>Request Body Schema</strong>
            <p>Array</p>
            <table>
              <tr>
                <td>
                  event_id
                </td>
                <td>
                  Unique string identifier of updated event sent.
                </td>
              </tr>
              <tr>
                <td>
                  occurred_at
                </td>
                <td>
                  Timestamp when a update event has occurred. The time and date must be in ISO 8601 format (YYYY-MM-DDTH24:MI:SSZ) and UTC timezone.
                </td>
              </tr>
              <tr>
                <td>
                  type
                </td>
                <td>
                  Event type. e.g - picked, printed or shipped
                </td>
              </tr>
              <tr>
                <td>
                  affected_item
                </td>
                <td>
                  Order line item identifier, unique in order
                </td>
              </tr>
              <tr>
                <td>
                  tracking_url
                </td>
                <td>
                  Package tracking URL (if type = shipped)
                </td>
              </tr>
              <tr>
                <td>
                  tracking_number
                </td>
                <td>
                  Package tracking code (if type = shipped)
                </td>
              </tr>
              <tr>
                <td>
                  carrier
                </td>
                <td>
                  Name of the carrier delivering package (if type = shipped)
                </td>
              </tr>
            </table>
            
            <strong>Request Example</strong>
            <div class="div-code">
              <code [innerHtml]='printedWebhookCode'></code>
            </div>

            <strong>Response</strong>
            <div>
              <b class="text-danger">Note :</b>
              <p>
                HTTP response status code should be 200 or 202
              </p>
            </div>
          </div>

          <br />
          <h3>Contact Us</h3>
          <p>If you have any questions, please contact us:</p>
          <ul>
            <li>By email: hello&#64;loop.com</li>
            <li>By phone number: 7024756921</li>
          </ul>
        </div>
      </div>
    </div>

  </div>
</div>